import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

class OtherFeeSearchParams extends SearchParamsBase {
  static saveType = 'OtherFeeSearchParams';
  initialize() {
    this.ServiceFeeId = '';
  }

  static fieldsInSearchBox = [
    { fieldName: 'ServiceFeeId', label: 'ID', className: 'col-3', type: InputTypesEnum.Number },
  ];

  static iconName = 'fa-solid fa-search';
}

export default OtherFeeSearchParams;
